import { ReactNode } from 'react';
import { Tooltip } from 'react-tooltip';
import { ChipColors } from '../../../theme';
import { ChipStyle } from './style';

type Props = {
  title: string | ReactNode;
  color?: ChipColors;
  centered?: boolean;
  tooltip?: string;
  isTitle?: boolean;
};
const sanitizeForCSS = (str) =>
  str
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9_-]/g, '')
    .toLowerCase();

const Chip = ({ title, color, centered = false, tooltip, isTitle = false }: Props) => {
  // An empty badge is just an outlined box; show nothing instead.
  if (title === undefined || title === null || title === '') return null;
  const id = isTitle ? 'headerTitle' : sanitizeForCSS(`chip-${title}-${color}`);
  return (
    <ChipStyle centered={centered} color={color} nocolor={isTitle ? true : false}>
      <span className={id}>{title}</span>
      {tooltip && <Tooltip anchorSelect={`.${id}`} place="top" content={tooltip} />}
    </ChipStyle>
  );
};

export default Chip;
